module.exports = __webpack_public_path__ + "static/KotoriRose-Regular-e09dfb5b70508099e430a52cc93b59a2.otf";